export { default as withScreenName, ScreenNameProvider, clearScreenName } from './screen-name-context';
